import type { CalculationResult } from '~/pages/IncomeCalculator/types';

import { FormTypes } from '../../../enums';
import BreakdownValue from '../styles/BreakdownValue';

type MedicareWagesProps = {
  selectedResult: CalculationResult;
  currentYear: number;
};

const MedicareWages = ({
  selectedResult,
  currentYear,
}: Readonly<MedicareWagesProps>) => {
  const medicareWages = selectedResult.getInputAsFloat(
    FormTypes.W2,
    currentYear,
    'medicareWages',
  );

  return (
    <BreakdownValue
      name="Wages:"
      value={medicareWages}
      isCurrency={true}
      fontWeight="bold"
    >
      <BreakdownValue name="W2 Box 5" value={medicareWages} />
    </BreakdownValue>
  );
};

export default MedicareWages;
